function messageNotificationVerifyUserDataInSubscription() {
  return `Para assinar um plano precisamos de seus dados pessoais.
    Acesse o menu Dados Pessoais e complete seu cadastro antes de continuar ou`
}

export default messageNotificationVerifyUserDataInSubscription
